import minBy from 'lodash/minBy';
import maxBy from 'lodash/maxBy';

import { Price } from '~api/api';

export interface PriceRange {
  min: number;
  max: number;
}

export function getPriceRange(prices: Price[]): PriceRange {
  return {
    min: (minBy(prices, 'value') as Price).value,
    max: (maxBy(prices, 'value') as Price).value,
  };
}

export const priceToString = (price: number) => {
  price = price / 100;
  return Number.isInteger(price) ? price.toString() : price.toFixed(2);
};

export function priceRangeToString(range: PriceRange) {
  if (range.min === range.max) {
    return priceToString(range.min);
  }

  return `${priceToString(range.min)} - ${priceToString(range.max)}`;
}
